/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  RepayUSDOptions,
  RepayUSDStatus201,
  RepayUSDStatus400,
  RepayUSDStatus401,
  RepayUSDStatus404,
  RepayUSDStatus409,
  RepayUSDStatus500,
} from '../types/RepayUSD'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { repayUSD } from '../clients/repayUSD'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const repayUSDMutationKey = () => [{ url: '/v1/positions/repay_usd' }] as const

export function repayUSDMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = repayUSDMutationKey()
  return mutationOptions<
    RepayUSDStatus201,
    ResponseErrorConfig<
      | RepayUSDStatus400
      | RepayUSDStatus401
      | RepayUSDStatus404
      | RepayUSDStatus409
      | RepayUSDStatus500
    >,
    RepayUSDOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return repayUSD({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Repay borrowed USD, then accrue and pay leverage interest
 * {@link /v1/positions/repay_usd}
 */
export function useRepayUSD<TContext>(
  options: {
    mutation?: UseMutationOptions<
      RepayUSDStatus201,
      ResponseErrorConfig<
        | RepayUSDStatus400
        | RepayUSDStatus401
        | RepayUSDStatus404
        | RepayUSDStatus409
        | RepayUSDStatus500
      >,
      RepayUSDOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? repayUSDMutationKey()

  const baseOptions = repayUSDMutationOptions(config) as UseMutationOptions<
    RepayUSDStatus201,
    ResponseErrorConfig<
      | RepayUSDStatus400
      | RepayUSDStatus401
      | RepayUSDStatus404
      | RepayUSDStatus409
      | RepayUSDStatus500
    >,
    RepayUSDOptions,
    TContext
  >

  return useMutation<
    RepayUSDStatus201,
    ResponseErrorConfig<
      | RepayUSDStatus400
      | RepayUSDStatus401
      | RepayUSDStatus404
      | RepayUSDStatus409
      | RepayUSDStatus500
    >,
    RepayUSDOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    RepayUSDStatus201,
    ResponseErrorConfig<
      | RepayUSDStatus400
      | RepayUSDStatus401
      | RepayUSDStatus404
      | RepayUSDStatus409
      | RepayUSDStatus500
    >,
    RepayUSDOptions,
    TContext
  >
}
